import actionTypes from '../actionTypes';

export const FETCH_PAYOUTS = actionTypes('FETCH_PAYOUTS');
export const FETCH_PAYOUT = actionTypes('FETCH_PAYOUT');
export const UPDATE_PAYOUT_STATUS = actionTypes('UPDATE_PAYOUT_STATUS');
export const RETRY_PAYOUT = actionTypes('RETRY_PAYOUT');
export const SET_CURRENT_ACTION = actionTypes('SET_CURRENT_ACTION');
export const CLEAR_MESSAGE = actionTypes('CLEAR_MESSAGE');
